import React from 'react';
import ReactDOM from 'react-dom';
import { initMercadoPago } from '@mercadopago/sdk-react';

import App from 'App';
import AppErrorBoundary from 'components/commons/AppErrorBoundary';
import * as serviceWorker from 'serviceWorker';
import { MERCADO_PAGO_PUBLIC_KEY } from 'constants/configs';

import 'index.scss';

// initMercadoPago(MERCADO_PAGO_PUBLIC_KEY, { locale: 'es-AR' });

const showMaintenancePage = (error) => {
  console.error('Storefront runtime error:', error);
  window.dispatchEvent(new Event('app:maintenance'));
};

window.addEventListener('error', (event) => {
  // Ignore failed static assets; only JavaScript execution errors take down the app.
  if (event.error) showMaintenancePage(event.error);
});

window.addEventListener('unhandledrejection', (event) => {
  showMaintenancePage(event.reason);
});

ReactDOM.render(
  <AppErrorBoundary><App /></AppErrorBoundary>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
